module.exports = kolibriCoreAppGlobal.coreVue.components.LanguageSwitcherList;